import { sortBy } from 'lodash';
import tube from './tube';
import foundation from './foundation';
// import rms from './rms';
import gaia from './gaia';
import ta from './ta';
import py from './py';

// TODO: RMS上線後重新啟用
// let links = [...tube, ...foundation, ...rms, ...ta, ...py];
let links = [...tube, ...foundation, ...gaia, ...ta, ...py];
links = sortBy(links, ['sort']);
export default links;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/index.js
 **/